import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {ModalService} from '../../../../components/modal';
import {OverlayService} from '../../../../components/overlay';
import {createDisplayDecimal, DisplayDecimal} from '../../../../components/symbol-decimals';
import {CellSizeObserverService} from '../../../../pages/dashboard/layout/cell/cell-size-observer.service';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';
import NumberFormat = Intl.NumberFormat;

@Component({
    selector: 'widget-order-step-alert',
    templateUrl: 'widget-order-step-alert.component.html',
    styleUrls: ['./widget-order-step-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderStepAlertComponent extends WidgetInnerAlertComponent implements OnInit {

    @Input()
    public override message: string;

    @Input()
    public step: number;

    @Input()
    public format: NumberFormat;

    public stepDisplayDecimal: DisplayDecimal<string>;

    constructor(
        elementRef: ElementRef,
        modalService: ModalService,
        overlayService: OverlayService,
        cellSizeObserverService: CellSizeObserverService,
        renderer: Renderer2
    ) {
        super(
            elementRef,
            modalService,
            overlayService,
            cellSizeObserverService,
            renderer
        );
    }

    public override ngOnInit(): void {
        this.stepDisplayDecimal = createDisplayDecimal(this.step, this.format);

        super.ngOnInit();
    }

}
